'use client'
import toast, { ToastBar, Toaster } from 'react-hot-toast'
import { XCloseIcon } from 'primitives/icons'
import { Typography } from '@repo/design-system-cf/components/typography'
import { IconWarning, IconCheckCircle, IconInfo } from '@repo/design-system-cf/components/icons'
import { tw } from 'utils/classnames'

import * as React from 'react'

export function ToasterCustom() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        success: {
          style: { margin: 0, padding: 0 },
        },
        error: {
          style: { margin: 0, padding: 0 },
        },
        loading: {
          style: { margin: 0, padding: 0 },
        },
        blank: {
          style: { margin: 0, padding: 0 },
        },
        custom: {
          style: { margin: 0, padding: 0 },
        },
        style: {
          minWidth: '320px',
          maxWidth: '400px',
          margin: 0,
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        },
      }}
    >
      {t => (
        <ToastBar toast={t}>
          {({ message }) => (
            <Toast
              onClose={() => toast.dismiss(t.id)}
              message={message || ''}
              type={t.type as 'success' | 'error' | 'loading' | 'notice'}
            />
          )}
        </ToastBar>
      )}
    </Toaster>
  )
}

export function Toast({
  message,
  type,
  standalone,
  onClose,
}: {
  message: string | JSX.Element
  type: 'error' | 'success' | 'notice' | 'loading'
  standalone?: boolean
  onClose: () => void
}) {
  return (
    <div
      className={tw('flex m-0 p-2.5 rounded-2 relative pl-5 box-content', {
        'bg-[#E7FDF1] border-green-500/5 border-r border-t border-b border-solid':
          type === 'success',
        'bg-[#FCE7EA] border-[#B5162D]/5 border-r border-t border-b border-solid': type === 'error',
        'bg-[#E7F3FF] border-blue-500/5 border-r border-t border-b border-solid': type === 'notice',
      })}
    >
      <div className="flex gap-2 grow">
        {type === 'error' ? <IconWarning className="text-cf-red-600 size-4 shrink-0" /> : null}
        {type === 'success' ? <IconCheckCircle className="text-[#0EAD5B] size-4 shrink-0" /> : null}
        {type === 'notice' ? <IconInfo className="text-[#0EAD5B] size-4 shrink-0" /> : null}
        <Typography
          variant="cf-heading-01"
          className={tw('whitespace-normal [word-break:break-word] grow m-0 [&_>div]:m-0', {
            'max-w-[260px]': !standalone,
          })}
        >
          {message}
        </Typography>
      </div>
      {type !== 'loading' ? (
        <div className="flex justify-center">
          <button onClick={onClose} className="flex">
            <XCloseIcon />
          </button>
        </div>
      ) : null}

      <div
        className={tw('absolute left-0 -inset-y-px w-2 z-0 rounded-l-2', {
          'border-green-500 bg-[#E7FDF1] border-l-8 border-solid': type === 'success',
          'border-[#B5162D] bg-[#FCE7EA] border-l-8 border-solid': type === 'error',
          'border-blue-500 bg-[#E7F3FF] border-l-8 border-solid': type === 'notice',
        })}
      />
    </div>
  )
}
